import _ from "lodash"
import ProgramIdentityIds from "./ProgramIdentityIds"
import ReferralIdentityId from "./ReferralIdentityId"
import ParticipantNoteList from "./ParticipantNoteList"
import ParticipantIds from "./ParticipantIds"
import ParticipantSSN from "./ParticipantSSN"
import StaffIdSelector from "./StaffIdSelector"
import StaffIds from "./StaffIds"
import LocationIds from "./LocationIds"
import ManageOrganizationIds from "./ManageOrganizationIds"
import ManageServicesType from "./ManageServicesType"
import StaffRole from "./StaffRole"
import StaffPrimarySupervisor from "./StaffPrimarySupervisor"
import StaffOrganizationId from "./StaffOrganizationId"
import PasswordUpdate from "./PasswordUpdate"
import AssessmentScore from "./AssessmentScore"
import AssessmentType from "./AssessmentType"
import EightAssesmentScore from "./EightAssesmentScore"
import SessionDate from "./SessionDate"
import SessionStartTime from "./SessionStartTime"
import FormDate from "./FormDate"
import FormStartTime from "./FormStartTime"
import CheckboxEnterpriseFeatures from "./EnterpriseFeatures"
import EnterpriseIds from "./EnterpriseIds"
import ParticipantAddressLivesLength from "./ParticipantAddressLivesLength"
import SupervisionStaffIdSelector from "./SupervisionStaffIdSelector"

import ManageStaffIdSelector from "./ManageStaffIdSelector"
import ManageProgramIdentityIds from "./ManageProgramIdentityIds"
import ManageLocationIds from "./ManageLocationIds"
import DemoBirthdate from "./DemoBirthdate"
import YesOrNo from "./YesOrNo"
import TelerecoveryOrgPhone from "./TelerecoveryOrgPhone"
import TelerecoveryStaffPhone from "./TelerecoveryStaffPhone"
import ProgramIdGpra from "./ProgramIdGpra"

import CheckboxEnterpriseMicroservices from "./CheckboxEnterpriseMicroservices"
import CheckboxOrganizationMicroservices from "./CheckboxOrganizationMicroservices"
import ParticipantPhonePrimaryNone from "./ParticipantPhonePrimaryNone"
import ParticipantAddressNone from "./ParticipantAddressNone"

import MultiOrganizationIdsByLocation from "./MultiOrganizationIdsByLocation.js"
import MultiOrganizationIdsByProgram from "./MultiOrganizationIdsByProgram.js"
import MultiProgramsIdsByLocation from "./MultiProgramsIdsByLocation.js"
import IdEnterprise from "./IdEnterprise.js"
import Owner from "./Owner.js"

import AccountTFA from "./AccountTFA"

export default function TypeSys(props) {
  const typeSplit = _.split(props.field.field_name, "__")
  const field_name = _.isEmpty(typeSplit[1])
    ? props.field.field_name
    : typeSplit[1]

  switch (field_name) {
    case "id_creator":
      return <Owner {...props} />
    case "enterprise_managed":
      return <IdEnterprise {...props} />
    case "multi_programs_ids_by_location":
      return <MultiProgramsIdsByLocation {...props} />
    case "multi_organization_ids_by_location":
      return <MultiOrganizationIdsByLocation {...props} />
    case "multi_organization_ids_by_program":
      return <MultiOrganizationIdsByProgram {...props} />
    case "program_identity_ids":
    case "session__program_identity_ids":
      return <ProgramIdentityIds {...props} />
    case "referral_entity_id":
      return <ReferralIdentityId {...props} />
    case "participant_note_list":
      return <ParticipantNoteList {...props} />
    case "staff_id_selector":
      if (props.field.field_name === "supervision_session__staff_id_selector") {
        return <SupervisionStaffIdSelector {...props} />
      } else {
        return (
          <StaffIdSelector
            {...props}
            autoSelectStaff={
              props.field.field_name === "document_staff__staff_id_selector"
            }
          />
        )
      }
    case "staff_ids":
      return <StaffIds {...props} />
    case "location_ids":
      return <LocationIds {...props} />
    case "manage_organization_ids":
      return <ManageOrganizationIds {...props} />
    case "manage_services_type":
      return <ManageServicesType {...props} />
    case "demo_ssn":
      return <ParticipantSSN {...props} />
    case "manage_staff_id_selector":
      return <ManageStaffIdSelector {...props} />
    case "manage_program_identity_ids":
      return <ManageProgramIdentityIds {...props} />
    case "manage_location_ids":
      return <ManageLocationIds {...props} />
    case "staff_primary_supervisor":
      return <StaffPrimarySupervisor {...props} />
    case "staff_role":
      return <StaffRole {...props} />
    case "staff_organization_id":
      return <StaffOrganizationId {...props} />
    case "participant_ids":
      return <ParticipantIds {...props} />
    case "password_update":
      return <PasswordUpdate {...props} />
    case "session_date":
      return <SessionDate {...props} />
    case "session_start_time":
      return <SessionStartTime {...props} />
    case "form_date":
      return <FormDate {...props} />
    case "form_start_time":
      return <FormStartTime {...props} />
    case "assessment_score":
      return <AssessmentScore {...props} />
    case "assessment_type":
      return <AssessmentType {...props} />
    case "enterprise_features":
      return <CheckboxEnterpriseFeatures {...props} />
    case "organization_enterprise_id":
      return <EnterpriseIds {...props} />
    case "assessment_8_dimensions":
      return <EightAssesmentScore {...props} />
    case "participant_address_lives_primary_length":
      return <ParticipantAddressLivesLength {...props} />
    case "demo_birthdate":
    case "account_birthdate":
      return <DemoBirthdate {...props} />
    case "staff_telerecovery_number_assignment":
      return <YesOrNo {...props} />
    case "organization_phone_telerecovery":
      return <TelerecoveryOrgPhone {...props} />
    case "staff_phone_telerecovery":
      return <TelerecoveryStaffPhone {...props} />
    case "program_id_gpra":
      return <ProgramIdGpra {...props} />
    case "enterprise_microservices":
      return <CheckboxEnterpriseMicroservices {...props} />
    case "organization_microservices":
      return <CheckboxOrganizationMicroservices {...props} />
    case "participant_phone_primary_none":
      return <ParticipantPhonePrimaryNone {...props} />
    case "participant_address_none":
      return <ParticipantAddressNone {...props} />
    case "profile_tfa_method":
      return <AccountTFA {...props} />
    default:
      return null
  }
}
